<template>
  <div class="flex w-full flex-col items-center overflow-auto">
    <div class="mt-4 text-xl">Select your images and metadata</div>
    <div
      v-if="imagesAndMetadata && imagesAndMetadata.length > 0"
      class="ring-opacity-5 mt-4 w-full overflow-auto shadow ring-1 ring-neutral-300 dark:ring-neutral-600 md:rounded-lg"
    >
      <table class="min-w-full divide-y divide-neutral-300 overflow-auto dark:divide-neutral-600">
        <thead class="bg-neutral-50 dark:bg-neutral-800">
          <tr>
            <th
              v-if="hasLocalData"
              scope="col"
              class="bg-opacity-75 sticky top-0 z-10 border-b border-neutral-300 bg-neutral-50 py-3.5 pl-3 pr-3 text-left text-sm font-semibold text-neutral-900 backdrop-blur backdrop-filter dark:border-neutral-600 dark:bg-neutral-800 dark:text-white sm:pl-20"
            >
              Name
            </th>
            <th
              v-if="hasRemoteData"
              scope="col"
              class="bg-opacity-75 sticky top-0 z-10 border-b border-neutral-300 bg-neutral-50 py-3.5 pl-3 pr-3 text-left text-sm font-semibold text-neutral-900 backdrop-blur backdrop-filter dark:border-neutral-600 dark:bg-neutral-800 dark:text-white sm:pl-20"
            >
              Data URIs
            </th>
            <th
              v-if="hasRemoteData"
              scope="col"
              class="bg-opacity-75 sticky top-0 z-10 border-b border-neutral-300 bg-neutral-50 px-3 py-3.5 text-left text-sm font-semibold text-neutral-900 backdrop-blur backdrop-filter dark:border-neutral-600 dark:bg-neutral-800 dark:text-white"
            >
              Metadata URIs
            </th>
            <th
              v-if="hasLocalData"
              scope="col"
              class="bg-opacity-75 sticky top-0 z-10 min-w-[20rem] border-b border-neutral-300 bg-neutral-50 px-3 py-3.5 text-left text-sm font-semibold text-neutral-900 backdrop-blur backdrop-filter dark:border-neutral-600 dark:bg-neutral-800 dark:text-white"
            >
              Description
            </th>
            <th
              v-if="hasLocalData && (hasSeries || automaticallyAddSeries)"
              scope="col"
              class="bg-opacity-75 sticky top-0 z-10 border-b border-neutral-300 bg-neutral-50 py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-neutral-900 backdrop-blur backdrop-filter dark:border-neutral-600 dark:bg-neutral-800 dark:text-white"
            >
              Series
            </th>
            <th
              v-if="hasEditions"
              scope="col"
              class="bg-opacity-75 sticky top-0 z-10 border-b border-neutral-300 bg-neutral-50 py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-neutral-900 backdrop-blur backdrop-filter dark:border-neutral-600 dark:bg-neutral-800 dark:text-white"
            >
              Edition
            </th>
            <th
              v-if="hasTargetAddress"
              scope="col"
              class="bg-opacity-75 sticky top-0 z-10 border-b border-neutral-300 bg-neutral-50 py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-neutral-900 backdrop-blur backdrop-filter dark:border-neutral-600 dark:bg-neutral-800 dark:text-white"
            >
              Target Address
            </th>
            <th
              v-if="hasRequestedNft"
              scope="col"
              class="bg-opacity-75 sticky top-0 z-10 border-b border-neutral-300 bg-neutral-50 py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-neutral-900 backdrop-blur backdrop-filter dark:border-neutral-600 dark:bg-neutral-800 dark:text-white"
            >
              Requested NFT
            </th>
            <th
              v-if="hasRequestedXch"
              scope="col"
              class="bg-opacity-75 sticky top-0 z-10 border-b border-neutral-300 bg-neutral-50 py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-neutral-900 backdrop-blur backdrop-filter dark:border-neutral-600 dark:bg-neutral-800 dark:text-white"
            >
              Price
            </th>
            <template v-if="hasLocalData">
              <th
                v-for="(key, index) in attributeKeys"
                :key="key"
                scope="col"
                :class="index === 0 ? 'border-l' : ''"
                class="bg-opacity-75 sticky top-0 z-10 border-b border-neutral-300 bg-neutral-50 px-3 py-3.5 text-left text-sm font-semibold text-neutral-900 backdrop-blur backdrop-filter dark:border-neutral-600 dark:bg-neutral-800 dark:text-white"
              >
                {{ key }}
              </th>
            </template>
          </tr>
        </thead>
        <tbody class="divide-y divide-neutral-200 bg-white dark:divide-neutral-600 dark:bg-neutral-900">
          <tr v-for="(data, index) in imagesAndMetadata.slice(0, 10)" :key="index">
            <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm">
              <div class="flex items-center">
                <div class="flex h-10 w-10 flex-shrink-0 items-center justify-center">
                  <!--                  <video-->
                  <!--                    v-if="isLocalData(data) && isVideo(data.imagePath)"-->
                  <!--                    :src="`file://${data.imagePath}`"-->
                  <!--                    class="h-10 w-10 rounded-md object-cover"-->
                  <!--                  />-->
                  <img
                    v-if="isLocalData(data)"
                    class="h-10 w-10 rounded-md object-cover"
                    :src="generateURL(data.dataFile)"
                    loading="lazy"
                    alt=""
                  />
                  <!--                  <video-->
                  <!--                    v-if="isRemoteData(data) && isVideo(data.dataUris[0])"-->
                  <!--                    :src="data.dataUris[0]"-->
                  <!--                    class="h-10 w-10 rounded-md object-cover"-->
                  <!--                  />-->
                  <img
                    v-else-if="isRemoteData(data)"
                    class="h-10 w-10 rounded-md object-cover"
                    :src="data.dataUris[0]"
                    loading="lazy"
                    alt=""
                  />
                </div>
                <div v-if="isLocalData(data)" class="ml-4 font-medium">
                  {{ data.metadata.name }}
                </div>
                <div v-if="isRemoteData(data)" class="ml-4 font-medium">
                  {{ data.dataUris }}
                </div>
              </div>
            </td>
            <td v-if="isLocalData(data)" class="whitespace-pre-wrap px-3 py-4 text-sm">
              {{ data.metadata.description }}
            </td>
            <td v-if="isRemoteData(data)" class="whitespace-nowrap px-3 py-4 text-center text-sm">
              {{ data.metadataUris }}
            </td>
            <td
              v-if="(hasSeries || automaticallyAddSeries) && isLocalData(data)"
              class="whitespace-nowrap px-3 py-4 text-center text-sm"
            >
              {{ data.metadata.series_number || index + 1 }} of
              {{ data.metadata.series_total || imagesAndMetadata?.length }}
            </td>
            <td v-if="hasEditions" class="whitespace-nowrap px-3 py-4 text-center text-sm">
              {{ data.onChainMetadata?.edition_number || 1 }} of {{ data.onChainMetadata?.edition_total || 1 }}
            </td>
            <td v-if="hasTargetAddress" class="whitespace-nowrap px-3 py-4 text-sm">
              <span v-if="data.onChainMetadata?.target_address" class="font-mono tracking-tighter">{{
                data.onChainMetadata?.target_address
              }}</span>
              <span v-else class="text-neutral-400">Your Wallet</span>
            </td>
            <td v-if="hasRequestedNft" class="whitespace-nowrap px-3 py-4 text-sm">
              <span v-if="data.requestedNft" class="font-mono tracking-tighter">{{ data.requestedNft }}</span>
            </td>
            <td v-if="hasRequestedXch" class="whitespace-nowrap px-3 py-4 text-sm">
              <span v-if="data.requestedXch" class="font-mono tracking-tighter">{{ data.requestedXch }} XCH</span>
            </td>
            <template v-if="isLocalData(data)">
              <td
                v-for="(key, attrIndex) in attributeKeys"
                :key="key"
                :class="attrIndex === 0 ? 'border-l border-neutral-300 dark:border-neutral-600' : ''"
                class="px-3 py-4 text-sm"
              >
                {{ getAttributeValueFromList(data.metadata.attributes, key) }}
              </td>
            </template>
          </tr>
        </tbody>
      </table>
      <div class="mt-4 flex flex-grow items-center justify-center">
        <button
          class="flex justify-center rounded-full border border-transparent px-4 py-3 font-semibold transition duration-100 ease-in-out"
          @click="resetFile()"
        >
          Remove
        </button>
      </div>
    </div>
    <div v-show="imagesAndMetadata === null" class="mt-4 w-full max-w-screen-lg">
      <MintDropZone ref="dropzone" type="directory" @update:model-value="loadAndSetFolder" />
      <div v-if="loadDirectoryError" class="mt-2 text-center text-sm text-red-600">
        {{ loadDirectoryError }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Ref } from 'vue';
import Papa from 'papaparse';
import { type ImagesAndMetadata, type Metadata, isLocalData, isRemoteData } from '~/types/minting';

const emit = defineEmits(['update:modelValue']);

const dropzone = ref(null);

const loadingDirectory = ref(false);
const loadDirectoryError = ref<string | undefined>(undefined);
const imagesAndMetadata: Ref<ImagesAndMetadata[] | null> = ref(null);

const automaticallyAddSeries = ref<boolean>(true);

const hasLocalData = computed(() => !!imagesAndMetadata.value?.find((data) => isLocalData(data)));
const hasRemoteData = computed(() => !!imagesAndMetadata.value?.find((data) => isRemoteData(data)));
const hasEditions = computed(
  () =>
    !!imagesAndMetadata.value?.find(
      ({ onChainMetadata }) => onChainMetadata?.edition_total && onChainMetadata?.edition_total > 1
    )
);
const hasSeries = computed(
  () =>
    !!imagesAndMetadata.value?.find(
      (imageAndMetadata) =>
        isLocalData(imageAndMetadata) &&
        imageAndMetadata.metadata.series_number! >= 1 &&
        imageAndMetadata.metadata.series_total! >= 1
    )
);
const hasTargetAddress = computed(
  () => !!imagesAndMetadata.value?.find(({ onChainMetadata }) => !!onChainMetadata?.target_address)
);
const hasRequestedNft = computed(() => !!imagesAndMetadata.value?.find(({ requestedNft }) => !!requestedNft));
const hasRequestedXch = computed(() => !!imagesAndMetadata.value?.find(({ requestedXch }) => requestedXch != null));

const loadAndSetFolder = async (selectedFiles: File[]) => {
  const topLevelFiles = [];
  for (const file of selectedFiles) {
    console.log(file.webkitRelativePath);
    if (file.webkitRelativePath.split('/').length === 2) {
      topLevelFiles.push(file);
    }
  }
  console.log(topLevelFiles);
  try {
    loadDirectoryError.value = undefined;
    imagesAndMetadata.value = await loadDirectory(topLevelFiles);
    await loadAttributes(imagesAndMetadata.value);
    emit('update:modelValue', imagesAndMetadata.value);
  } catch (e) {
    loadDirectoryError.value = e?.error?.message || e?.message || 'Unknown error';
  }
};

const resetFile = () => {
  imagesAndMetadata.value = null;
  emit('update:modelValue', []);
};

// const openFilePicker = () => {
//   document.querySelector<HTMLInputElement>('#dropzoneFileLabel')?.click();
// };

const attributeKeys = ref<any>([]);
const attributes = ref<{ [key: string]: string }>({});
const loadAttributes = (imagesAndMetadata: ImagesAndMetadata[]) => {
  loadingDirectory.value = true;
  loadDirectoryError.value = undefined;
  try {
    const attributeKeySet = new Set();
    const newAttributes: { [key: string]: string } = {};
    for (const input of imagesAndMetadata) {
      if (isLocalData(input) && input.metadata.attributes?.length > 0) {
        for (const attribute of input.metadata.attributes) {
          attributeKeySet.add(attribute.trait_type);
        }
        attributeKeys.value = [...attributeKeySet];
        attributes.value = newAttributes;
      }
    }

    // if (
    //   !!imagesAndMetadata.value.find(({ requestedNft, requestedXch }) => requestedNft != null || requestedXch != null)
    // ) {
    //   createOfferFiles.value = true;
    // }
  } catch (error: any) {
    console.error(error);
    loadDirectoryError.value = error?.error?.message || error?.message || 'Unknown error';
  } finally {
    loadingDirectory.value = false;
  }
};

const getAttributeValueFromList = (attributes: any[], key: string) =>
  attributes?.find((attribute) => (attribute.trait_type || attribute.name) === key)?.value;

async function loadDirectory(files: File[]): Promise<ImagesAndMetadata[]> {
  const imageAndMetadataPaths: ImagesAndMetadata[] = [];
  const metadataFile = files.find((file) => file.name === 'metadata.csv');
  if (metadataFile) {
    console.log('assume CSV');
    const getAttributes = (entry: { [key: string]: string }) => {
      return Object.keys(entry)
        .filter(
          (key) =>
            ![
              'id', // Bueno
              'image', // Bueno
              'name',
              'Name',
              'file',
              'File',
              'data_uris',
              'Data URIs',
              'data_hash',
              'Data Hash',
              'metadata_uris',
              'Metadata URIs',
              'metadata_hash',
              'Metadata Hash',
              'description',
              'Description',
              'edition_number',
              'Edition Number',
              'edition_total',
              'Edition Total',
              'series_number',
              'Series Number',
              'series_total',
              'Series Total',
              'sensitive_content',
              'Sensitive Content',
              'requested_xch',
              'Requested XCH',
              'requested_nft',
              'Requested NFT',
              'target_address',
              'Target Address',
            ].includes(key)
        )
        .map((key) => ({ trait_type: key, value: entry[key] }))
        .filter(({ value }) => !!value?.trim());
    };

    const metadataCsv = await readCsv(metadataFile);

    for (const entry of metadataCsv) {
      // const id = entry.id;
      const filename = entry.file || entry.File;
      const dataUris = entry.data_uris || entry['Data URIs'];

      // let imagePath: string | undefined = undefined;
      // if (id) {
      //   console.log('assume bueno');
      //   const uuidPattern = /^([0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})(?![\w.])/i;
      //
      //   const imageFolder = files.find((name) => name.match(uuidPattern));
      //   if (imageFolder) {
      //     const imageFolderContent = await readdir(path.join(selectedPath, imageFolder));
      //     const imageFile = imageFolderContent.find((otherFile) => {
      //       const parsedData = path.parse(otherFile);
      //       return parsedData.name === id;
      //     });
      //     if (imageFile) {
      //       imagePath = path.join(selectedPath, imageFolder, imageFile);
      //     }
      //   }
      // } else if (file) {
      const dataFile = files.find((file) => file.name === filename);
      // }

      const baseMetadata = {
        onChainMetadata: {
          edition_number: parseInt(entry.edition_number || entry['Edition Number']) || undefined,
          edition_total: parseInt(entry.edition_total || entry['Edition Total']) || undefined,
          target_address: entry.target_address || entry['Target Address'] || undefined,
        },
        requestedXch: parseFloat(entry.requested_xch || entry['Requested XCH']) || undefined,
        requestedNft: entry.requested_nft || entry['Requested NFT'] || undefined,
      };

      if (dataFile) {
        const metadata: Metadata = {
          name: entry.name || entry.Name,
          description: entry.description || entry.Description,
          attributes: getAttributes(entry),
        };
        metadata.series_number = parseInt(entry.series_number || entry['Series Number']) || undefined;
        metadata.series_total = parseInt(entry.series_total || entry['Series Total']) || undefined;
        metadata.sensitive_content =
          String(entry.sensitive_content || entry['Sensitive Content']).toLowerCase() === 'true';

        imageAndMetadataPaths.push({
          ...baseMetadata,
          dataFile,
          metadata,
        });
      } else if (dataUris) {
        const dataHash = entry.data_hash || entry['Data Hash'];
        const metadataUris = entry.metadata_uris || entry['Metadata URIs'];
        const metadataHash = entry.metadata_hash || entry['Metadata Hash'];

        imageAndMetadataPaths.push({
          ...baseMetadata,
          dataUris: dataUris.split(','),
          dataHash: dataHash.replace('0x', ''),
          metadataUris: metadataUris.split(','),
          metadataHash: metadataHash.replace('0x', ''),
        });
      }
    }
  } else {
    throw new Error('No metadata.csv file found');
  }
  return imageAndMetadataPaths.sort((a, b) => {
    const aFilename = 'dataFile' in a ? a.dataFile.name : a.dataUris[0].split('/').pop()!;
    const bFilename = 'dataFile' in b ? b.dataFile.name : b.dataUris[0].split('/').pop()!;
    return aFilename.localeCompare(bFilename, undefined, { numeric: true, sensitivity: 'base' });
  });
}

const readCsv = async (file: File): Promise<{ [key: string]: string }[]> => {
  try {
    const result = await new Promise<Papa.ParseResult<{ [key: string]: string }>>((resolve, reject) => {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: resolve,
        error: reject,
        transformHeader: (header: string) => header.trim(),
      });
    });

    if (result.data.length > 0 && Object.keys(result.data[0]).length >= 3) {
      return result.data;
    }
  } catch (error) {
    throw new Error('Error parsing CSV: ' + error);
  }

  return [];
};

const objectUrls = ref<string[]>([]);

function generateURL(file?: File) {
  if (!file) {
    return undefined;
  }
  const fileSrc = URL.createObjectURL(file);
  if (!objectUrls.value.includes(fileSrc)) {
    objectUrls.value.push(fileSrc);
  }
  return fileSrc;
}

onUnmounted(() => {
  objectUrls.value.forEach((url) => {
    URL.revokeObjectURL(url);
  });
});
</script>
